/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'window'
],
function(
  window
){
  var view = {
    selectors: {
      buybeltATC: '#atc_shipIt',
      mediaGalleryThumbnails: '#thumbnails'
    }
  }

  var newRelicReportMethods = {
    newRelicEvent: function newRelicEvent(event, payload) {
      /* This GLOBAL PUBLIC function is defined in src/main/resources/mustaches/criticalJavascript.mustache */
      window.sendNewRelicEvent(event, payload);      //eslint-disable-line no-undef
    },

    reportBuyBeltTiming: function reportBuyBeltTiming() {
      $(view.selectors.buybeltATC).ready(function() {
        newRelicReportMethods.newRelicEvent("BUYBELT_FINISH_TIME", Date.now());
      });
    },

    reportMediaGalleryTiming: function reportMediaGalleryTiming() {
      $(view.selectors.mediaGalleryThumbnails).ready(function() {
        newRelicReportMethods.newRelicEvent("MEDIA_GALLERY_FINISH_TIME", Date.now());
      });
    }
  }  

  return {
    init: function initNewRelic() {
        newRelicReportMethods.reportBuyBeltTiming();
        newRelicReportMethods.reportMediaGalleryTiming();
    },
    newRelicEvent: newRelicReportMethods.newRelicEvent
  }

});

}.call(window));